<script setup>
import {ref} from 'vue';

defineProps({
  placeholder: {type: String, default: 'Введіть пароль'},
  name: {type: String, default: 'password'},
  autocomplete: {type: String, default: 'off'},
  label: {type: String, default: ''},
  error: {type: [String, Boolean], default: ''},
  modelValue: {type: String, default: ''},
  disabled: {type: Boolean, default: false},
});

const emit = defineEmits(['update:modelValue', 'change']);
const type = ref('password');
const setType = () => type.value === 'password' ? type.value = 'text' : type.value = 'password';
</script>

<template>
  <div class="form-control" :class="{error}">
    <label class="label fs-10" v-if="label" :for="`id-${name}`">
      {{ label }}
    </label>
    <div class="input-group relative-input" :class="{'disabled': disabled}">
      <input
        :id="`id-${name}`"
        class="input fs-12"
        :name="name"
        :value="modelValue"
        :type="type"
        :autocomplete="autocomplete"
        :placeholder="placeholder"
        :disabled="disabled"
        @input="emit('update:modelValue', $event.target.value)"
        @change="emit('change', $event.target.value)"
      >
      <button class="input__btn default__btn" @click="setType">
        <i class="i-eye" />
      </button>
    </div>
    <small class="error fs-10" v-show="error && typeof error === 'string'">
      <sup>*</sup>{{ error }}
    </small>
  </div>
</template>
